import * as SettingsActionTypes from 'actiontypes/settings';
import SettingsService from 'services/SettingsService';

const service = new SettingsService();

export const linkEmailToAccountRequested = () => ({
  type: SettingsActionTypes.LINK_EMAIL_TO_ACCOUNT_REQUESTED,
  isLinkingEmail: true,
});

export const linkEmailToAccountSuccess = response => ({
  type: SettingsActionTypes.LINK_EMAIL_TO_ACCOUNT_SUCCESS,
  isLinkingEmail: false,
  isSuccess: response.isSuccess,
  message: response.message,
});

export const linkEmailToAccountFailure = error => ({
  type: SettingsActionTypes.LINK_EMAIL_TO_ACCOUNT_FAILURE,
  isLinkingEmail: false,
  error: true,
  status: error.response && error.response.status,
});

export default function linkEmailToAccount(data) {
  return (dispatch) => {
    dispatch(linkEmailToAccountRequested());

    return service.linkEmailToAccount(data).then(
      response => dispatch(linkEmailToAccountSuccess(response.data)),
      error => dispatch(linkEmailToAccountFailure(error)),
    );
  };
}
